import __base_store from '@/store/__base_store'

/**
 * Store de tipo de comprobante AFIP (modelo `afip_tipo_comprobante`).
 * Construido desde el factory común.
 */
export default __base_store({
	/** Estado propio del modelo. */
	state: {
		model_name: 'afip_tipo_comprobante',
	},
})

